import { render, staticRenderFns } from "./ReviewSelector.vue?vue&type=template&id=11b181bd"
import script from "./ReviewSelector.vue?vue&type=script&lang=js"
export * from "./ReviewSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports